<script setup>
import { onMounted } from 'vue'
import Loading from 'vue-loading-overlay'

import ImoConfirm from '@/components/modal/ImoConfirm.vue'
import ImoModalManager from '@/components/modal/ImoModalManager.vue'
import SidePanelManager from '@/components/sidepanel/SidePanelManager.vue'
import { useHotjar } from '@/composables/useHotjar'
import { useLoadStore } from '@/stores/Loader'

const loadStore = useLoadStore()

onMounted(() => {
  useHotjar()
})
</script>

<template>
  <div id="app">
    <Loading
      v-if="loadStore.loading"
      :active="loadStore.loading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <router-view />
    <div id="modalsrender" />

    <!-- SidePanel Manager Global -->
    <SidePanelManager />

    <!-- Modal de confirmação global -->
    <ImoConfirm />

    <!-- Modal Manager global -->
    <ImoModalManager />
  </div>
</template>
